import { PRODUCTION } from 'constants/application_constants';

const log = (...args) => {
  if (!PRODUCTION) {
    console.log(...args);
  }
};

export default log;
